"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const patrones = ["Operación de flotilla en turismo", "Procesos notariales con OCR e IA", "Servicios aeroportuarios B2B", "RRHH con AdagioRH", "Reportería ejecutiva automotriz", "Pipeline comercial inmobiliario", "Operación retail y e-commerce"];
export default function SectoresDondeOperamos() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="sobre-sectores" id="sectores" className="bg-background text-foreground py-24 md:py-32 overflow-hidden border-t border-border/30">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-normal text-foreground leading-tight mb-10">
            Patrones que hemos resuelto.
          </h2>

          <div className="font-sans text-lg md:text-xl text-foreground/90 leading-relaxed mb-12 max-w-3xl">
            <p className="flex flex-wrap gap-x-2 gap-y-3">
              {patrones.map((patron, i) => <React.Fragment key={i}>
                  <span>{patron}</span>
                  {i < patrones.length - 1 && <span className="text-primary font-mono">·</span>}
                </React.Fragment>)}
            </p>
          </div>

          <p className="font-sans text-base md:text-lg italic text-muted-foreground leading-relaxed max-w-2xl border-t border-border/30 pt-8">
            Más importante que el sector es el patrón de operación. Si tu operación tiene procesos repetibles, datos que viven en silos y herramientas que no se hablan, Fulcro aplica.
          </p>
        </div>
      </div>
    </section>;
}